<template>
  <div>
    <el-select :value="value" value-key="user" :size="size" :placeholder="$t('table.operator')" @input="change($event)" :clearable="true">
      <el-option label="中国移动" value="CMCC" />
      <el-option label="中国电信" value="CTCC" />
      <el-option label="中国联通" value="CUCC" />
      <el-option label="中国广电" value="CBN" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/OperatorSelect.vue